import request from '@/utils/request'

export function fetchDownloadTaskList(params) {
  return request({
    url: '/merchant-api/fileDownload/task/list',
    method: 'get',
    params
  })
}

